import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, EmptyState } from "@/components/admin/AdminPrimitives";
import { FileText, Plus } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/conteudos")({
  head: () => ({ meta: [{ title: "Conteúdos — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: () => (
    <div>
      <PageHeader
        title="Conteúdos"
        description="Artigos, aulas e materiais editoriais."
        actions={
          <button className="inline-flex items-center gap-1.5 rounded-lg bg-[var(--navy)] px-3 py-2 text-sm font-semibold text-white hover:opacity-90">
            <Plus size={14} /> Novo conteúdo
          </button>
        }
      />
      <EmptyState
        icon={FileText}
        title="Editor de conteúdos em preparação"
        description="Aqui você poderá publicar artigos, aulas em vídeo e materiais complementares vinculados aos negócios da biblioteca."
      />
    </div>
  ),
});
